import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL3 } from '../Config/Base';
import { BASE_URL } from '../Config/Base';
import { Oval } from  'react-loader-spinner'
const pageSize = 5;
const pageSizeB = 5;

const OatHomeMain = () => {

// GET request using fetch()

let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
const token = JSON.parse(localStorage.getItem('usertoken'));

const[pop,setpop] = useState(false);

const [allusers, setAllusers] = useState([])


const [paginatedPosts, setpaginatedPosts] = useState();
const [currentPage, setcurrentPage] = useState(1);


const [allusersB, setAllusersB] = useState([])


const [paginatedPostsB, setpaginatedPostsB] = useState();
const [currentPageB, setcurrentPageB] = useState(1);




useEffect(()=>{  
  document.getElementById("AssignTable-Oat").style.display="none"

 
  getUsers()
  setpop(true);
  setTimeout(() => {
            
    getroleAction() 
    
     }, 1000);
  setTimeout(() => {
          
    setpop(false);
    getAssignedAction()
  
      
     }, 2000);


}, [])
function getroleAction(){


  let LoginRole= localStorage.getItem("Role");
  
 
  console.log('checkrole',LoginRole);
  const body =
  {
    
   role:LoginRole
  }
  console.log('body',body);
 
 
  axios({
         method:"POST",
         url :`${BASE_URL}/oat/GetOatRoleAction`,
         data:body, 
         headers: {
              "Content-type": "application/json",
              "Authorization": bearer,
          }     
      }) 
      
 
      .then((response) =>{
        console.log(response.data);
   
     
     
              
        localStorage.setItem("LoginAction",JSON.stringify(response.data))
        localStorage.getItem("LoginAction");
     })
     .catch(error => {
       console.log(error);
 })
 }
 function getAssignedAction(){



  ////Admin
    
    let LoginRoleId= localStorage.getItem("RoleId");

    let CheckSAdmin = LoginRoleId.includes("00")
    let CheckAdmin =LoginRoleId.includes("01")


  /////////////Teammate
    let LoginAction =  localStorage.getItem("LoginAction");
    let TecRoleAction =  JSON.parse(LoginAction);
    let roleAction = TecRoleAction.map((e)=>e.roleAction);
    console.log(roleAction);
    
    let roles = roleAction.toString();
    let roleResult = roles.includes('Add')
    console.log(roleResult)
    
    let roleResultA = roles.includes('View')
    console.log(roleResultA)
    
    let roleResultB = roles.includes('Edit')
    console.log(roleResultB)
    
    let roleResultC = roles.includes('Delete')
    console.log(roleResultC)


   

   
    if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById('AssignTable-Oat').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('AssignTable-Oat').style.display ="block";
    }
    else{
      document.getElementById('AssignTable-Oat').style.display ="none";

    }

    if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById("OatActionDenied").innerHTML="View Table Denied"
    }
    
  }

  function getAssignedActionA(){



    ////Admin
      
      let LoginRoleId= localStorage.getItem("RoleId");
  
      let CheckSAdmin = LoginRoleId.includes("00")
      let CheckAdmin =LoginRoleId.includes("01")
  
  
    /////////////Teammate
      let LoginAction =  localStorage.getItem("LoginAction");
      let TecRoleAction =  JSON.parse(LoginAction);
      let roleAction = TecRoleAction.map((e)=>e.roleAction);
      console.log(roleAction);
      
      let roles = roleAction.toString();
      let roleResult = roles.includes('Add')
      console.log(roleResult)
      
      let roleResultA = roles.includes('View')
      console.log(roleResultA)
      
      let roleResultB = roles.includes('Edit')
      console.log(roleResultB)
      
      let roleResultC = roles.includes('Delete')
      console.log(roleResultC)
  
  
     
  
     
      if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('CompleteTable-Oat').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('CompleteTable-Oat').style.display ="block";
      }
      else{
        document.getElementById('CompleteTable-Oat').style.display ="none";
  
      }

      if( roleResultA==false  && CheckSAdmin==false && CheckAdmin==false){

        document.getElementById("OatActionDeniedA").innerHTML="View Table Denied"
      }
      
    }
    
function getUsers(){

    

fetch(`${BASE_URL}/OatMain/GetTask`, {

  method: 'GET',

  headers: {

    "Content-type": "application/json",

    "Accept": "application/json",

   

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

  },

  //body:JSON.stringify(data)

}).then(response => response.json())

  .then(data => {
    console.log("Data", data);
    setAllusers(data);
    setpaginatedPosts(_(data).slice(0).take(pageSize).value());
      }
  );

console.log("check",allusers)


    }

    const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
    // if (pageCount === 1)
    // return null;
    
    const pages = _.range(1, pageCount+1)
   
    const pagination =(pageNo)=>{
    setcurrentPage(pageNo);
    const startIndex = (pageNo - 1) * pageSize;
    const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
    setpaginatedPosts(paginatedPost)
    }
    const onNext = () => {


      pagination(currentPage + 1);
    };
  
    const onPrevious = () => {
      pagination(currentPage - 1);
    };



    
// GET request using fetch()






function getUsersB(){

    

fetch(`${BASE_URL}/OatMain/GetNotify`, {

  method: 'GET',

  headers: {

    "Content-type": "application/json",

    "Accept": "application/json",

   

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

  },

  //body:JSON.stringify(data)

}).then(response => response.json())

  .then(data => {
    console.log("Data", data);
    setAllusersB(data);
    setpaginatedPostsB(_(data).slice(0).take(pageSizeB).value());
      }
  );

console.log("check",allusersB)


    }

    const pageCountB = allusersB? Math.ceil(allusersB.length/pageSizeB) :0;
    // if (pageCount === 1)
    // return null;
    
    const pagesB = _.range(1, pageCountB+1)

     




    const paginationB =(pageNoB)=>{
    setcurrentPageB(pageNoB);
    const startIndexB = (pageNoB - 1) * pageSizeB;
    const paginatedPostB = _(allusersB).slice(startIndexB).take(pageSizeB).value();
    setpaginatedPostsB(paginatedPostB)
    }


    const onNextB = () => {


      paginationB(currentPageB + 1);
    };
  
    const onPreviousB = () => {
      paginationB(currentPageB - 1);
    };

  function OpenAssignedTask(){
    document.getElementById("OatAssignedtaskTable").style.display="none"
    getUsers()
    setpop(true);
    
    document.getElementById("OatCompletetaskTable").style.display="none"
    document.getElementById("oatCompleteBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
   document.getElementById("oatAssignedBtn").style.background="rgb(249, 249, 249)"
   document.getElementById("oatAssignedBtn").style.color="black"
   document.getElementById("oatCompleteBtn").style.color="White"
  setTimeout(() => {
    setpop(false);  
    getAssignedAction()
    document.getElementById("OatAssignedtaskTable").style.display="block"
    
     }, 1000);

  }

  function OpenCompletetask(){
   
    getUsersB()
    document.getElementById("OatCompletetaskTable").style.display="none"
    setpop(true);
   
    document.getElementById("OatAssignedtaskTable").style.display="none"
    document.getElementById("oatAssignedBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatCompleteBtn").style.background="rgb(249, 249, 249)"
    document.getElementById("oatCompleteBtn").style.color="black"
    document.getElementById("oatAssignedBtn").style.color="White"
    setTimeout(() => {
      
      setpop(false);  
      getAssignedActionA()
      document.getElementById("OatCompletetaskTable").style.display="block"
  }, 1000);
 
  }
  return (
    <>
    
    <div className='oat-addmain'>

    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
        
    <div className="oat-addgrid-layout">
    
  <div className="oat-addmain-top">
  
    <span className='OatTitle'>
    <span>HOME</span></span>
    <div className='oat-addmain-back'>
      <Link to="/Oatsection"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
   
    </div>
    </div>
    
      <div id="OatButton" >
           <div id="OatSectionHide">
            <button id="oatAssignedBtn" onClick={OpenAssignedTask}>Assigned task</button>
            <button id="oatCompleteBtn" onClick={OpenCompletetask}>Completed task</button>
             </div>

      </div>

      <div id="OatAssignedtaskTable">
    
      <div id="AssignTable-Oat">
      {
  allusers.length==0 ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
        <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>
<th style={{whiteSpace:"nowrap"}}>Task_Id</th>
<th style={{whiteSpace:"nowrap"}}>Company_Id</th>
<th style={{whiteSpace:"nowrap"}}>Admin_Id</th>
<th style={{whiteSpace:"nowrap"}}>Description</th>

{/* <th>Seen</th>
<th>Created_Date</th> */}



</tr>
</thead>
<tbody>
{paginatedPosts.map((e,index) => {
      return<tr key={index}>

           <td><div style={{inlineSize:"100px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.taskId}</div></td>
          <td><div style={{inlineSize:"100px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.companyId}</div></td>
          <td><div style={{inlineSize:"250px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.adminId}</div></td>
          <td><div style={{inlineSize:"250px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.description}</div></td>
         
          {/* <td>{e.seen}</td>
          <td>{e.created_Date}</td> */}
          
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCount==1?null: <nav id="oatpagenav" style={{marginTop:"50px"}}>
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}
       
       {currentPage >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="oatpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
           
    </ul>
  </nav>}
  </div>)} 
  </div>
  <div id="OatDenied">
   <span id="OatActionDenied"></span>

   </div>
        </div>
        
      <div id="OatCompletetaskTable">
        <div id="CompleteTable-Oat">
        {
 allusersB.length==0  ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
      <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>
{/* <th>Notification_Id</th> */}
{/* <th>User_Id</th>
<th>Time</th> */}
<th style={{whiteSpace:"nowrap"}}> Description</th>
<th style={{whiteSpace:"nowrap"}}>Company_Id</th>
{/* <th>Type</th>
<th>Seen</th> */}
<th style={{whiteSpace:"nowrap"}}>Contact_Id</th>

<th style={{whiteSpace:"nowrap"}}>Company_Name</th>
<th>Count</th>
<th>Status</th>
</tr>
</thead>
<tbody>
{paginatedPostsB.map((e,index) => {
      return<tr key={index}>

           {/* <td>{e.notify_Id}</td> */}
          {/* <td>{e.userId}</td>
          <td>{e.time}</td> */}
          <td>{e.description}</td>
          <td>{e.company_Id}</td>
          {/* <td>{e.type}</td>
          <td>{e.seen}</td> */}
          <td>{e.contact_Id}</td>
          <td>{e.company_Name}</td>
          <td>{e.count}</td>
          <td>{e.status}</td>
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCountB==1?null:<nav id="oatpagenav" style={{marginTop:"50px"}}>
    <ul className='pagination'>


      {/* {
        pagesB.map((page)=>(
          
          <>
         
          <li className={
            page === currentPageB ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>paginationB(page)}
            >
            {page}
            </p>
            </li>

            
            </>
        ))
      } */}


        {currentPageB >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPreviousB} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageB} Of {pageCountB} 
         
            </span>   &nbsp; &nbsp;
        {currentPageB<pageCountB?<li className="page-item">
              <a class="oatpage-link" onClick={onNextB} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
           
    </ul>
  </nav>}
  </div>
  )} 
  </div>
  <div id="OatDenied">
   <span id="OatActionDeniedA"></span>

   </div>
        </div>
        
        {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}

      </div>
    </>
  )
}

export default OatHomeMain
